<h1 class="center" *ngIf="!isHotel"> Historique des jours d'activités </h1>
<h1 class="center" *ngIf="isHotel"> Historique des nuitées </h1>

<div class="historique-page" class="flex justify-center">
    <div class="clamp-commande">
        <table class="styled-table" *ngIf="!isLingerie">
            <thead>
                <tr>
                    <th>Année</th>
                    <th *ngFor="let mois of listMoisAbv">{{mois}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of listYearStatsLH">
                    <td>{{element.annee}}</td>
                    <td *ngFor="let data of element.list">{{data.jours}}</td>
                </tr>
            </tbody>
        </table>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl1" class="example-tree" *ngIf="isLingerie">
            <mat-nested-tree-node *matTreeNodeDef="let lingerie">
                <div>
                    <div class="mat-tree-node">
                        <button type="button" mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + lingerie.id">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl1.isExpanded(lingerie) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <div>{{lingerie.libelle}}</div>
                    </div>
                    <div [class.example-tree-invisible]="!treeControl1.isExpanded(lingerie)" class="content-node">
                        <table class="styled-table">
                            <thead>
                                <tr>
                                    <th>Année</th>
                                    <th *ngFor="let mois of listMoisAbv">{{mois}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of lingerie.children">
                                    <td>{{element.annee}}</td>
                                    <td *ngFor="let data of element.list">{{data.jours}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    </div>
</div>

<h1 class="center" *ngIf="isHotel"> Historique des chambres </h1>
<h1 class="center" *ngIf="isSante"> Historique des lits </h1>

<div class="historique-page" *ngIf="isSante || isHotel" class="flex justify-center">
    <div class="clamp-commande">
        <table class="styled-table" *ngIf="!isLingerie">
            <thead>
                <tr>
                    <th>Année</th>
                    <th *ngFor="let mois of listMoisAbv">{{mois}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of listYearStatsLH">
                    <td>{{element.annee}}</td>
                    <td *ngFor="let data of element.list">{{data.emplacements}}</td>
                </tr>
            </tbody>
        </table>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl2" class="example-tree" *ngIf="isLingerie">
            <mat-nested-tree-node *matTreeNodeDef="let lingerie">
                <div>
                    <div class="mat-tree-node">
                        <button type="button" mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + lingerie.id">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl2.isExpanded(lingerie) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <div>{{lingerie.libelle}}</div>
                    </div>
                    <div [class.example-tree-invisible]="!treeControl2.isExpanded(lingerie)" class="content-node">
                        <table class="styled-table">
                            <thead>
                                <tr>
                                    <th>Année</th>
                                    <th *ngFor="let mois of listMoisAbv">{{mois}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of lingerie.children">
                                    <td>{{element.annee}}</td>
                                    <td *ngFor="let data of element.list">{{data.emplacements}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mat-nested-tree-node>
        </mat-tree>

        <div class="statsLH-buttons">
            <button mat-stroked-button (click)="refuse()">Retour</button>
        </div>
    </div>
</div>